module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-up.ff6f3009.svg";